import { LineShareIos } from '@qr-front/icons/line-share-ios'
import { Checkbox } from '@qr-front/ui/components/Checkbox'
import { useAtom } from 'jotai'
import { atomWithReset, RESET } from 'jotai/utils'
import { useTranslations } from 'next-intl'
import { forwardRef, useImperativeHandle } from 'react'

import { getStore } from '@/store'
import { TTranslationFunction } from '@/types'

import {
	TContentFormHandle,
	TQrContentFormSection,
} from '../qrContentFormTypes'

export const SHARE_VIDEO_FORM_ID = 'share-video'

export const shareVideoAtom = atomWithReset(true)

export const resetShareVideoForm = () => {
	getStore().set(shareVideoAtom, RESET)
}

const ShareVideoForm = forwardRef<TContentFormHandle>((_, ref) => {
	const t = useTranslations()

	useImperativeHandle(
		ref,
		() => ({
			validate: () => Promise.resolve({ isValid: true }),
		}),
		[],
	)

	const [isShareEnabled, setIsShareEnabled] = useAtom(shareVideoAtom)

	return (
		<fieldset>
			<Checkbox
				checked={isShareEnabled}
				onCheckedChange={(checked) => setIsShareEnabled(!!checked)}
				id="share-video"
				label={t(
					'generator__content_form_section__share_video__checkbox_label',
				)}
			/>
		</fieldset>
	)
})

ShareVideoForm.displayName = 'ShareVideoForm'

export const shareVideoFormConfig = (
	t: TTranslationFunction,
): TQrContentFormSection => ({
	id: SHARE_VIDEO_FORM_ID,
	title: t('generator__share_qr_dialog__title'),
	description: t('generator__content_form_section__share_video__description'),
	icon: <LineShareIos />,
	Content: ShareVideoForm,
})
